/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {toAbsoluteUrl} from '../../../helpers'
import {useNavigate} from 'react-router-dom'

const HeaderUserMenu: FC = () => {
  const history = useNavigate()
  const handleLogout = () => {
    history('/open-account/auth/sign-in')
    localStorage.removeItem('currentUser')
  }
  return (
    <nav className='navbar navbar-expand-lg navbar-light bg-light flex-row-reverse'>
      <button
        onClick={handleLogout}
        className='btn btn-outline-success bg-secondary my-2 my-sm-0 mx-8'
      >
        Sign out
      </button>
    </nav>
  )
}

export {HeaderUserMenu}
